import { LatLngInterface } from '../interfaces/api';

export class LatLng implements LatLngInterface {

    lat: number;

    lng: number;

    static createFromObject(object: any): LatLng {
        let location = new LatLng();
        if (object.lat !== undefined) location.lat = object.lat;
        if (object.lng !== undefined) location.lng = object.lng;
        return location;
    }
}



// WEBPACK FOOTER //
// ./src/entities/latlng.ts